import { render } from "./FormModal.vue?vue&type=template&id=668cd28a&scoped=true"
import script from "./FormModal.vue?vue&type=script&lang=js"
export * from "./FormModal.vue?vue&type=script&lang=js"

import "./FormModal.vue?vue&type=style&index=0&id=668cd28a&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\one8-web\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-668cd28a"]])

export default __exports__